import { ImagiseError } from '@imagise/shared';

export const log = (
  severity: 'log' | 'warn' | 'error',
  ...optionalParams: unknown[]
) => console[severity]('canvas', ...optionalParams);

export class CanvasFilterError extends ImagiseError {
  constructor(message?: string) {
    super(message);
  }
}

export class CanvasRuntimeError extends CanvasFilterError {
  constructor(message?: string) {
    super(message);
  }
}

export class SignalAbortedError extends CanvasFilterError {
  constructor(context: string) {
    super(`${context} 'options.signal' is in 'aborted' state`);
  }
}
